import React from "react";
import styles from "./ArticleSection.module.less";

export interface Props {
    heading: string;
    headingImage?: string;
    children: React.ReactNode;
    borderless?: boolean;
}

export default function ArticleSection(props: Props) {
    return (
        <div
            className={[styles.ArticleSection, props.borderless ? styles["ArticleSection--borderless"] : "", props.headingImage ? styles["ArticleSection--withImage"] : ""].join(" ")}
        >
            <div className={styles["ArticleSection-heading"]}>
                <h2 className="Heading Heading--h3"> {props.heading}</h2>
                {props.headingImage ? <img src={props.headingImage} alt={props.heading} className={styles["ArticleSection-img"]} /> : null}
            </div>
            <div className={styles["ArticleSection-content"]}>{props.children}</div>
        </div>
    );
}
